<mat-card class="stats-card">
  <mat-card-header>
    <mat-card-title>Estadísticas de Jugadores</mat-card-title>
  </mat-card-header>

  <mat-card-content class="stats-card-content">
    <ng-container *ngIf="playerStats && playerStats.length > 0; else noStats">
      <mat-tab-group class="stats-tabs" animationDuration="0ms">

        <mat-tab [label]="matchInfo?.home_team_name || 'Equipo Local'">
          <div class="table-container">
            <table mat-table [dataSource]="homePlayers" class="stats-table">

              <ng-container matColumnDef="dorsal">
                <th mat-header-cell *matHeaderCellDef>#</th>
                <td mat-cell *matCellDef="let row">{{ row.dorsal || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="playerName">
                <th mat-header-cell *matHeaderCellDef>Jugador</th>
                <td mat-cell *matCellDef="let row">
                  <a [routerLink]="['/statistics/player', row.player_id]" class="player-link">
                    {{ row.player_name }}
                  </a>
                </td>
              </ng-container>

              <ng-container matColumnDef="goals">
                <th mat-header-cell *matHeaderCellDef class="centered-header">Goles</th>
                <td mat-cell *matCellDef="let row" class="centered-cell">{{ row.goals }}</td>
              </ng-container>

              <ng-container matColumnDef="exclusions">
                <th mat-header-cell *matHeaderCellDef class="centered-header">Exclusiones</th>
                <td mat-cell *matCellDef="let row" class="centered-cell">{{ row.exclusions }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </mat-tab>

        <mat-tab [label]="matchInfo?.away_team_name || 'Equipo Visitante'">
          <div class="table-container">
            <table mat-table [dataSource]="awayPlayers" class="stats-table">

              <ng-container matColumnDef="dorsal">
                <th mat-header-cell *matHeaderCellDef>#</th>
                <td mat-cell *matCellDef="let row">{{ row.dorsal || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="playerName">
                <th mat-header-cell *matHeaderCellDef>Jugador</th>
                <td mat-cell *matCellDef="let row">
                  <a [routerLink]="['/statistics/player', row.player_id]" class="player-link">
                    {{ row.player_name }}
                  </a>
                </td>
              </ng-container>

              <ng-container matColumnDef="goals">
                <th mat-header-cell *matHeaderCellDef class="centered-header">Goles</th>
                <td mat-cell *matCellDef="let row" class="centered-cell">{{ row.goals }}</td>
              </ng-container>

              <ng-container matColumnDef="exclusions">
                <th mat-header-cell *matHeaderCellDef class="centered-header">Exclusiones</th>
                <td mat-cell *matCellDef="let row" class="centered-cell">{{ row.exclusions }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </mat-tab>
      </mat-tab-group>
    </ng-container>

    <ng-template #noStats>
      <div class="no-stats-container">
        <mat-icon>query_stats</mat-icon>
        <span>No hay estadísticas de jugadores disponibles para este partido.</span>
      </div>
    </ng-template>

  </mat-card-content>
</mat-card>
